import React from 'react';

import { Grid, Grow, Typography } from '@mui/material';

import { FormDataConsumer } from 'react-admin';
import RuleSelect from '../../../layout/ruleSelectDialog/RuleSelect';

import { mapRuleParamsForm, ruleDescriptions } from '../../ruleFeatures';
import { RuleNames } from '../../../../constants/ruleNames';
import TextInput from '../../../layout/inputFields/TextField';

const RuleParameters = ({ name }: {name: RuleNames}) => {
  const RuleParametersComponent = mapRuleParamsForm[name];

  return (
    <Grow in>
      <Grid container spacing={6}>
        <Grid size={12}>
          <Typography variant="description">
            {ruleDescriptions[name]}
          </Typography>
        </Grid>
        <Grid
          container
          spacing={1}
          size={12}
        >
          <Grid size={12}>
            <Typography variant="label">Rule name (Optional)</Typography>
          </Grid>
          <Grid size={12}>
            <TextInput
              label="Enter a name for the rule"
              source="customName"
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid
          display={RuleParametersComponent ? 'block' : 'none'}
          size={12}
        >
          <Typography variant="label" fontWeight="bold">Rule parameters</Typography>
        </Grid>
        <Grid size={12}>
          {RuleParametersComponent && <RuleParametersComponent />}
        </Grid>
      </Grid>
    </Grow>
  );
};

const RuleLogic = () => (
  <Grid container>
    <Grid
      container
      spacing={1}
      size={12}
    >
      <Grid size={12}>
        <Typography variant="label">Rule type</Typography>
      </Grid>
      <Grid size={12}>
        <RuleSelect />
      </Grid>
    </Grid>
    <FormDataConsumer>
      {({ formData }) => formData?.name && (
        <RuleParameters name={formData.name} />
      )}
    </FormDataConsumer>
  </Grid>
);

export default RuleLogic;
